import React from 'react'

const ConsumerIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="consumerIcon">
      <path
        d="M29.755 21.345C29.6612 21.2368 29.5452 21.15 29.415 21.0905C29.2847 21.0309 29.1432 21.0001 29 21H27V19C27 17.898 26.103 17 25 17H21C19.897 17 19 17.898 19 19V21H17C16.8567 21 16.715 21.0308 16.5846 21.0903C16.4542 21.1498 16.3382 21.2367 16.2443 21.345C16.1504 21.4533 16.0809 21.5805 16.0405 21.718C16 21.8555 15.9896 22.0001 16.01 22.142L17.01 29.142C17.0442 29.3802 17.1631 29.5981 17.3449 29.7557C17.5268 29.9133 17.7594 30 18 30H28C28.2406 30 28.4732 29.9133 28.6551 29.7557C28.8369 29.5981 28.9558 29.3802 28.99 29.142L29.99 22.142C30.0103 22.0001 29.9997 21.8554 29.9592 21.7179C29.9187 21.5804 29.849 21.4532 29.755 21.345ZM21 19H25V21H21V19ZM27.133 28H18.867L18.153 23H27.847L27.133 28ZM10 20H12V30H10V20Z"
        fill="#EF8658"
      />
      <path
        d="M16.78 17.875L14.874 15.491L13.432 11.886C13.2105 11.3284 12.8263 10.8503 12.3294 10.514C11.8326 10.1776 11.246 9.99854 10.646 10H5C3.346 10 2 11.346 2 13V20C2 21.103 2.897 22 4 22H5V30H7V20H4V13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H10.646C11.057 12 11.422 12.247 11.574 12.629L13.219 16.625L15.219 19.125L16.78 17.875ZM4 5C4 2.794 5.794 1 8 1C10.206 1 12 2.794 12 5C12 7.206 10.206 9 8 9C5.794 9 4 7.206 4 5ZM6 5C6 6.103 6.897 7 8 7C9.103 7 10 6.103 10 5C10 3.897 9.103 3 8 3C6.897 3 6 3.897 6 5Z"
        fill="#EF8658"
      />
    </g>
  </svg>
)

export default ConsumerIcon
